import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HotelPreview } from '../../../results/results.container';


@Component({
  selector: 'app-villa-preview',
  templateUrl: './villa-preview.component.html',
  styleUrls: ['./villa-preview.component.css']
})
export class VillaPreviewComponent implements OnInit {
    @Input() hotelPreviewInfo: HotelPreview;
    constructor(
    ) {

    }

    ngOnInit() { }

    getStars = (stars) => Array(stars).fill(1);

    getVillaUniqueUrl() {
        return this.hotelPreviewInfo.title.toLowerCase().replace(/\s/g, '-') + '-' + this.hotelPreviewInfo.id;
    }

    // f this listener will load the current image and the next when clicked in the carousel
    onSlide({prev, current, direction}) {
//      console.log('slideChange: ' + current);
      if (this.hotelPreviewInfo.pictures[current]) {
          this.hotelPreviewInfo.pictures[current].preloaded = true;
      }
      if (this.hotelPreviewInfo.pictures[current + 1]) {
          this.hotelPreviewInfo.pictures[current + 1].preloaded = true;
      }
  }

}
